import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar el miedo (y no huir de él)",
    opening: localizedGenderNode(
      [
      "Hoy dejo de ignorar el miedo.",
      "No intento calmarlo — lo escucho."
    ],
      [
      "Hoy dejo de ignorar el miedo.",
      "No intento calmarlo — lo escucho."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Y me digo en el corazón:",
      "“Esto es miedo. No es una profecía.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Y me digo en el corazón:",
      "“Esto es miedo. No es una profecía.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura — para mí\nMe pregunto:\n¿Cuál es exactamente la frase que me asusta?\n(“No volveré a encontrar el amor”, “Algo está mal en mí”, “Todos encontraron amor menos yo”)",
      "Me pregunto:\n¿Dónde se sienta este miedo en mi cuerpo?\n(pecho / estómago / garganta / hombros)",
      "Me pregunto:\n¿Cuándo aparece este miedo con más fuerza?\n(¿de noche? ¿en citas? ¿cuando veo a otros?)"
    ],
      [
      "Escritura — para mí\nMe pregunto:\n¿Cuál es exactamente la frase que me asusta?\n(“No volveré a encontrar el amor”, “Algo está mal en mí”, “Todos encontraron amor menos yo”)",
      "Me pregunto:\n¿Dónde se sienta este miedo en mi cuerpo?\n(pecho / estómago / garganta / hombros)",
      "Me pregunto:\n¿Cuándo aparece este miedo con más fuerza?\n(¿de noche? ¿en citas? ¿cuando veo a otros?)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El miedo no significa verdad.",
      "El miedo dice: “Me duele, y necesito seguridad.”"
    ],
      [
      "Cierre",
      "El miedo no significa verdad.",
      "El miedo dice: “Me duele, y necesito seguridad.”"
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy — una mano en el cuerpo + la frase:",
      "Una vez hoy — una mano en el cuerpo + la frase:"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El miedo como voz, no como hecho",
    opening: localizedGenderNode(
      [
      "Hoy aprendo a distinguir entre una voz interna y la realidad."
    ],
      [
      "Hoy aprendo a distinguir entre una voz interna y la realidad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo.",
      "Una respiración.",
      "“No todo pensamiento es verdad.”"
    ],
      [
      "Me detengo.",
      "Una respiración.",
      "“No todo pensamiento es verdad.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué me dice el miedo sobre mi futuro?",
      "¿Qué hecho real tengo ahora — sin interpretación?",
      "¿Qué parte de mí habla a través de este miedo?\n(la niña/el niño que fue abandonado, la parte que se desilusionó, la parte cansada)",
      "¿Qué verdad suave puedo elegir hoy en lugar de la voz que asusta?\n(una frase solamente)"
    ],
      [
      "Escritura\n¿Qué me dice el miedo sobre mi futuro?",
      "¿Qué hecho real tengo ahora — sin interpretación?",
      "¿Qué parte de mí habla a través de este miedo?\n(la niña/el niño que fue abandonado, la parte que se desilusionó, la parte cansada)",
      "¿Qué verdad suave puedo elegir hoy en lugar de la voz que asusta?\n(una frase solamente)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No tengo que creer cada voz que pasa por mí."
    ],
      [
      "Cierre",
      "No tengo que creer cada voz que pasa por mí."
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparece la frase que asusta — me detengo y respiro una vez antes de continuar.",
      "Cuando aparece la frase que asusta — me detengo y respiro una vez antes de continuar."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "De dónde nació este miedo",
    opening: localizedGenderNode(
      [
      "Hoy comprendo que el miedo no empezó hoy."
    ],
      [
      "Hoy comprendo que el miedo no empezó hoy."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuándo sentí algo parecido en el pasado?\n(una relación anterior, infancia, experiencia de rechazo)",
      "¿Qué aprendí entonces sobre el amor?",
      "¿Esa regla todavía tiene que ser verdad hoy?",
      "¿Qué parte de mí sigue actuando según una regla vieja?"
    ],
      [
      "Escritura\n¿Cuándo sentí algo parecido en el pasado?\n(una relación anterior, infancia, experiencia de rechazo)",
      "¿Qué aprendí entonces sobre el amor?",
      "¿Esa regla todavía tiene que ser verdad hoy?",
      "¿Qué parte de mí sigue actuando según una regla vieja?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Lo que aprendí entonces — no tiene que dirigir mi vida hoy."
    ],
      [
      "Cierre",
      "Lo que aprendí entonces — no tiene que dirigir mi vida hoy."
    ]
    ),
    action: localizedGenderNode(
      "Me escribo:",
      "Me escribo:"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La comparación con otros (y la mentira que hay en ella)",
    opening: localizedGenderNode(
      [
      "Hoy dejo de medir mi camino con el ritmo de otros."
    ],
      [
      "Hoy dejo de medir mi camino con el ritmo de otros."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo.",
      "Una respiración.",
      "“Mi camino no tiene que parecerse al de nadie.”"
    ],
      [
      "Me detengo.",
      "Una respiración.",
      "“Mi camino no tiene que parecerse al de nadie.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Con quién me comparo?",
      "¿Qué imagino que ellos tienen y yo no?",
      "¿Qué no veo en su camino?",
      "¿Qué verdad sobre mi propio camino estoy dispuesto/a a recordar hoy?"
    ],
      [
      "Escritura\n¿Con quién me comparo?",
      "¿Qué imagino que ellos tienen y yo no?",
      "¿Qué no veo en su camino?",
      "¿Qué verdad sobre mi propio camino estoy dispuesto/a a recordar hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La comparación no construye amor — solo desgasta el corazón."
    ],
      [
      "Cierre",
      "La comparación no construye amor — solo desgasta el corazón."
    ]
    ),
    action: localizedGenderNode(
      "Hoy evito una comparación a propósito.",
      "Hoy evito una comparación a propósito."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "La vergüenza (“Algo está mal en mí”)",
    opening: localizedGenderNode(
      [
      "Hoy toco la vergüenza sin dejar que me defina."
    ],
      [
      "Hoy toco la vergüenza sin dejar que me defina."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo.",
      "Una respiración.",
      "“La vergüenza no dice verdad. Dice que me duele.”"
    ],
      [
      "Me detengo.",
      "Una respiración.",
      "“La vergüenza no dice verdad. Dice que me duele.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué es lo que me da vergüenza sobre las relaciones?",
      "Si un amigo querido dijera esto de sí mismo — ¿qué le diría yo?",
      "¿Cómo suena esa misma frase en una versión humana y suave?",
      "¿Qué frase de compasión elijo para mí hoy?"
    ],
      [
      "Escritura\n¿Qué es lo que me da vergüenza sobre las relaciones?",
      "Si un amigo querido dijera esto de sí mismo — ¿qué le diría yo?",
      "¿Cómo suena esa misma frase en una versión humana y suave?",
      "¿Qué frase de compasión elijo para mí hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La vergüenza quiere que me esconda.",
      "Yo elijo quedarme."
    ],
      [
      "Cierre",
      "La vergüenza quiere que me esconda.",
      "Yo elijo quedarme."
    ]
    ),
    action: localizedGenderNode(
      "Una mano en el pecho + mi frase de compasión una sola vez.",
      "Una mano en el pecho + mi frase de compasión una sola vez."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Desarmar el mito del “amor único”",
    opening: localizedGenderNode(
      [
      "Hoy suelto la idea de que había una sola oportunidad."
    ],
      [
      "Hoy suelto la idea de que había una sola oportunidad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo.",
      "Una respiración."
    ],
      [
      "Me detengo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿De dónde viene la idea de que hay “un solo amor”?",
      "¿Qué prueba tengo de que esto es realmente verdad?",
      "¿Qué verdad más amplia existe sobre relaciones y personas?",
      "¿Qué significa para mí si el próximo amor es distinto — no una copia?"
    ],
      [
      "Escritura\n¿De dónde viene la idea de que hay “un solo amor”?",
      "¿Qué prueba tengo de que esto es realmente verdad?",
      "¿Qué verdad más amplia existe sobre relaciones y personas?",
      "¿Qué significa para mí si el próximo amor es distinto — no una copia?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El amor no se termina porque una relación terminó."
    ],
      [
      "Cierre",
      "El amor no se termina porque una relación terminó."
    ]
    ),
    action: localizedGenderNode(
      "Escribo:",
      "Escribo:"
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Pausar en medio de una profecía",
    opening: localizedGenderNode(
      [
      "Hoy practico detener una profecía antes de que se vuelva identidad."
    ],
      [
      "Hoy practico detener una profecía antes de que se vuelva identidad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo.",
      "Una respiración."
    ],
      [
      "Me detengo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué profecía me cuento sobre mí?",
      "¿Qué daño me hago cuando la creo?",
      "¿Qué otra posibilidad existe — aunque no la sienta ahora?",
      "¿Qué frase de detención quiero adoptar?"
    ],
      [
      "Escritura\n¿Qué profecía me cuento sobre mí?",
      "¿Qué daño me hago cuando la creo?",
      "¿Qué otra posibilidad existe — aunque no la sienta ahora?",
      "¿Qué frase de detención quiero adoptar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El futuro no se escribe con miedo — se construye con pasos."
    ],
      [
      "Cierre",
      "El futuro no se escribe con miedo — se construye con pasos."
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparece una profecía — digo mi frase de detención.",
      "Cuando aparece una profecía — digo mi frase de detención."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Qué sí busco en el amor",
    opening: localizedGenderNode(
      [
      "Hoy muevo el foco del miedo — al valor."
    ],
      [
      "Hoy muevo el foco del miedo — al valor."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo.",
      "Una respiración."
    ],
      [
      "Me detengo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué es realmente importante para mí en una relación?",
      "¿Qué necesidad mía no tuvo lugar en el pasado?",
      "¿Qué valor quiero que me guíe de ahora en adelante?",
      "¿Cómo puedo darme un poco de eso ya hoy?"
    ],
      [
      "Escritura\n¿Qué es realmente importante para mí en una relación?",
      "¿Qué necesidad mía no tuvo lugar en el pasado?",
      "¿Qué valor quiero que me guíe de ahora en adelante?",
      "¿Cómo puedo darme un poco de eso ya hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El amor empieza en la relación que construyo conmigo."
    ],
      [
      "Cierre",
      "El amor empieza en la relación que construyo conmigo."
    ]
    ),
    action: localizedGenderNode(
      "Hoy hago una acción que honra el valor que elegí.",
      "Hoy hago una acción que honra el valor que elegí."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "El miedo a las citas (y a ser visto/a)",
    opening: localizedGenderNode(
      [
      "Hoy toco el miedo sin cerrarme."
    ],
      [
      "Hoy toco el miedo sin cerrarme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo.",
      "Una respiración."
    ],
      [
      "Me detengo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué es lo que más me asusta de las citas?",
      "¿Qué temo que vean en mí?",
      "¿Qué olvido sobre mi derecho a ser yo?",
      "¿Qué verdad quiero recordar antes de un encuentro humano?"
    ],
      [
      "Escritura\n¿Qué es lo que más me asusta de las citas?",
      "¿Qué temo que vean en mí?",
      "¿Qué olvido sobre mi derecho a ser yo?",
      "¿Qué verdad quiero recordar antes de un encuentro humano?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No necesito impresionar para ser digno/a."
    ],
      [
      "Cierre",
      "No necesito impresionar para ser digno/a."
    ]
    ),
    action: localizedGenderNode(
      "Si hay un encuentro — llego como soy, sin añadidos.",
      "Si hay un encuentro — llego como soy, sin añadidos."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "La paciencia como cualidad emocional",
    opening: localizedGenderNode(
      [
      "Hoy practico la paciencia sin rendirme a mí mismo/a."
    ],
      [
      "Hoy practico la paciencia sin rendirme a mí mismo/a."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo.",
      "Una respiración."
    ],
      [
      "Me detengo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿En qué me apresuro demasiado?",
      "¿Cuál es el costo de esta presión?",
      "¿Cómo se ve una paciencia que no renuncia a la vida?",
      "¿Qué ritmo es correcto para mí ahora?"
    ],
      [
      "Escritura\n¿En qué me apresuro demasiado?",
      "¿Cuál es el costo de esta presión?",
      "¿Cómo se ve una paciencia que no renuncia a la vida?",
      "¿Qué ritmo es correcto para mí ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El ritmo no significa estancamiento.",
      "El ritmo significa escucha."
    ],
      [
      "Cierre",
      "El ritmo no significa estancamiento.",
      "El ritmo significa escucha."
    ]
    ),
    action: localizedGenderNode(
      "Elijo hacer una cosa hoy sin apurarme.",
      "Elijo hacer una cosa hoy sin apurarme."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Recuperar control (lo que sí está en mis manos)",
    opening: localizedGenderNode(
      [
      "Hoy reduzco el miedo a una acción."
    ],
      [
      "Hoy reduzco el miedo a una acción."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo.",
      "Una respiración."
    ],
      [
      "Me detengo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué no está bajo mi control — y hoy lo suelto?",
      "¿Qué sí está bajo mi control? (3 cosas pequeñas)",
      "¿Qué paso único hago esta semana?"
    ],
      [
      "Escritura\n¿Qué no está bajo mi control — y hoy lo suelto?",
      "¿Qué sí está bajo mi control? (3 cosas pequeñas)",
      "¿Qué paso único hago esta semana?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre"
    ],
      [
      "Cierre"
    ]
    ),
    action: localizedGenderNode(
      "Acción pequeña",
      "Acción pequeña"
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Amar incluso con miedo",
    opening: localizedGenderNode(
      [
      "Hoy doy lugar a dos sentimientos juntos."
    ],
      [
      "Hoy doy lugar a dos sentimientos juntos."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo.",
      "Una respiración."
    ],
      [
      "Me detengo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cómo pueden coexistir miedo y amor dentro de mí?",
      "¿Qué parte de mí quiere conexión — incluso cuando tiene miedo?",
      "¿Qué puedo prometerme dentro de una relación futura?"
    ],
      [
      "Escritura\n¿Cómo pueden coexistir miedo y amor dentro de mí?",
      "¿Qué parte de mí quiere conexión — incluso cuando tiene miedo?",
      "¿Qué puedo prometerme dentro de una relación futura?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El coraje no significa que no haya miedo.",
      "El coraje significa que no dejo que me detenga."
    ],
      [
      "Cierre",
      "El coraje no significa que no haya miedo.",
      "El coraje significa que no dejo que me detenga."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una promesa para mí.",
      "Escribo una promesa para mí."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Esperanza realista",
    opening: localizedGenderNode(
      [
      "Hoy construyo una esperanza que no depende de la fantasía."
    ],
      [
      "Hoy construyo una esperanza que no depende de la fantasía."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo.",
      "Una respiración."
    ],
      [
      "Me detengo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué es una esperanza real para mí?",
      "¿Qué dejo de esperar que pase “antes”?",
      "¿Cómo se ve una buena vida incluso ahora?"
    ],
      [
      "Escritura\n¿Qué es una esperanza real para mí?",
      "¿Qué dejo de esperar que pase “antes”?",
      "¿Cómo se ve una buena vida incluso ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La esperanza se construye mientras vivo, no antes."
    ],
      [
      "Cierre",
      "La esperanza se construye mientras vivo, no antes."
    ]
    ),
    action: localizedGenderNode(
      "Hago una cosa que me conecta con la vida hoy.",
      "Hago una cosa que me conecta con la vida hoy."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave y apertura de camino",
    opening: localizedGenderNode(
      [
      "Hoy no prometo amor — prometo presencia."
    ],
      [
      "Hoy no prometo amor — prometo presencia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\nTres cosas que dejo de decirme sobre el amor:",
      "Tres cosas que empiezo a creer:",
      "Frase de camino para días difíciles:"
    ],
      [
      "Escritura\nTres cosas que dejo de decirme sobre el amor:",
      "Tres cosas que empiezo a creer:",
      "Frase de camino para días difíciles:"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del recorrido",
      "Puede que no sepa cuándo llegará el amor.",
      "Pero sé quién soy cuando lo encuentro.",
      "Y me quedo conmigo —",
      "despacio, en silencio, con presencia.",
      "Y eso es fuerza."
    ],
      [
      "Cierre final del recorrido",
      "Puede que no sepa cuándo llegará el amor.",
      "Pero sé quién soy cuando lo encuentro.",
      "Y me quedo conmigo —",
      "despacio, en silencio, con presencia.",
      "Y eso es fuerza."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una acción que simbolice apertura a la vida — sin presión.",
      "Elijo una acción que simbolice apertura a la vida — sin presión."
    ),
  },
].map(buildNormalizedDay);

export const fearNeverFindLoveAgainBlueprintEs = buildNormalizedPilotBlueprint({
  id: "fear_never_find_love_again_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "fear_never_find_love_again",
  category: "general",
  journeyName: {
    he: "פחד “אני לא אמצא שוב אהבה”",
    en: "Fear: “I Will Not Find Love Again”",
    es: "Miedo: “No volveré a encontrar el amor”",
  },
  days,
});

export default fearNeverFindLoveAgainBlueprintEs;
